<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="m15.6 16.8-3.3-2.1h-.6L9.5 16a.5.5 0 0 1-.8-.5l.7-2.6-.1-.5-2.1-1.7a.5.5 0 0 1 .3-.9l2.6-.1q.3 0 .5-.4l1-2.4c.1-.4.7-.4.9 0l1 2.4q0 .3.4.4l2.6.1q.8.2.3 1l-2.3 1.8M20 12a2 2 0 0 1 1.5-2q.5 0 .5-.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v3.5q0 .4.5.6a2 2 0 0 1 0 3.8q-.5.2-.5.6V18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3.5q0-.5-.5-.6A2 2 0 0 1 20 12"
    />
  </svg>
</template>
